(function () {
  const assistant = document.querySelector('[data-bmr-assistant]');

  if (!assistant) return;

  const panel = assistant.querySelector('[data-assistant-panel]');
  const toggle = assistant.querySelector('[data-assistant-toggle]');
  const close = assistant.querySelector('[data-assistant-close]');
  const messages = assistant.querySelector('[data-assistant-messages]');
  const chatForm = assistant.querySelector('[data-assistant-chat]');
  const chatInput = assistant.querySelector('[data-assistant-chat-input]');
  const searchUrl = assistant.dataset.searchUrl || '/search';
  const predictiveSearchUrl = assistant.dataset.predictiveSearchUrl || '/search/suggest';
  const productTitle = assistant.dataset.productTitle;
  let introducedProduct = false;

  const answers = {
    drops:
      'Shop by drop: <a href="/collections/new-arrivals">New arrivals</a>, <a href="/collections/best-seller">Best sellers</a>, <a href="/collections/t-shirts-1">T-Shirts</a>, <a href="/collections/hoodies">Hoodies</a>, and <a href="/collections/music">Music</a>.',
    size:
      'All active shirt drops use normal US sizes: S, M, L, XL, XXL, and 3XL. Most pieces are heavyweight streetwear fits. Choose your usual size for a relaxed fit, or size down if you want it closer.',
    checkout:
      'For easy checkout, choose color and size, add to cart, then review your order in <a href="/cart">Cart</a>. If a size is unavailable, pick another color or check the latest drops.',
    order:
      'For order support, keep your order number and email ready. Use the <a href="/pages/contact">contact page</a> if available, or reply to your order confirmation email so support can trace it fast.',
    shipping:
      'Shipping rates and delivery options appear at checkout after you enter your address. Double-check your delivery address before payment so the order moves cleanly.',
    returns:
      'For returns or exchanges, contact support with your order number, item, size, and the issue. Keep the product unworn and in original condition while support reviews it.',
  };

  const topicLabels = {
    drops: 'Latest drops',
    size: 'Size help',
    checkout: 'Checkout help',
    order: 'Order support',
    shipping: 'Shipping',
    returns: 'Returns',
  };

  const keywordReplies = [
    {
      keywords: ['hello', 'hi', 'hey', 'yo', 'good morning', 'good afternoon', 'good evening'],
      reply:
        'Hey, welcome to Black Market. I can help you find drops, compare sizes, search products, and get through checkout.',
    },
    {
      keywords: ['how are you', 'what up', "what's up", 'sup'],
      reply:
        'I am here and ready to help you shop. Tell me what you are looking for: T-shirts, hoodies, music, best sellers, or a specific logo.',
    },
    {
      keywords: ['thank', 'thanks', 'appreciate'],
      reply: 'Anytime. Keep shopping clean and easy. I am here if you need another product or size check.',
    },
    {
      keywords: ['help', 'what can you do', 'what do you do', 'assistant'],
      reply:
        'I can answer store questions, suggest collections, help with US sizes, explain checkout, and search products. Try typing "show hoodies", "bubble headz", "what size", or "checkout help".',
    },
    {
      keywords: ['t shirt', 'tee', 'tees', 'shirt', 'shirts', 't-shirts'],
      reply:
        'You can shop all current shirts here: <a href="/collections/t-shirts-1">T-Shirts</a>. Most active tees are heavyweight 550 GSM or 600 GSM drops with US sizes S through 3XL.',
    },
    {
      keywords: ['hoodie', 'hoodies'],
      reply:
        'Hoodies live here: <a href="/collections/hoodies">Hoodies</a>. If you want the full catalog, check <a href="/collections/all">all drops</a> too.',
    },
    {
      keywords: ['music', 'song', 'track', 'album', 'beat'],
      reply: 'For Black Market music, go to <a href="/collections/music">Music</a>.',
    },
    {
      keywords: ['new arrival', 'new arrivals', 'new drop', 'new drops', 'latest', 'drop'],
      reply: answers.drops,
    },
    {
      keywords: ['best seller', 'best sellers', 'popular', 'top selling'],
      reply: 'Start with <a href="/collections/best-seller">Best sellers</a> for the strongest current picks.',
    },
    {
      keywords: ['size', 'sizing', 'fit', 'small', 'medium', 'large', 'xl', 'xxl', '3xl', 'oversized'],
      reply: answers.size,
    },
    {
      keywords: ['color', 'colors', 'black', 'white', 'orange', 'green', 'red', 'grey', 'gray', 'beige', 'khaki'],
      reply:
        'Most shirt drops have multiple colors. Open the product page, choose your color first, then choose size. If one color is sold out, try another color or check <a href="/collections/new-arrivals">new arrivals</a>.',
    },
    {
      keywords: ['bubble', 'bubble headz'],
      reply:
        'Bubble Headz is available in both <a href="/products/bubble-headz-550-gsm-t-shirt">550 GSM</a> and <a href="/products/bubble-headz-600-gsm-t-shirt">600 GSM</a>. You can also <a href="/search?type=product&q=bubble">search Bubble Headz</a>.',
    },
    {
      keywords: ['sgw', 'soft ground', 'wrestling'],
      reply:
        'SGW has two versions: <a href="/products/sgw-logo-version-1-600-gsm-t-shirt">Version 1</a> and <a href="/products/sgw-logo-version-2-600-gsm-t-shirt">Version 2</a>.',
    },
    {
      keywords: ['circle logo', 'bmr circle'],
      reply: 'The BMR Circle Logo tee is here: <a href="/products/bmr-circle-logo-550-gsm-t-shirt">BMR Circle Logo 550 GSM T-Shirt</a>.',
    },
    {
      keywords: ['africa logo', 'bmr africa'],
      reply: 'The BMR Africa Logo tee is here: <a href="/products/bmr-africa-logo-550-gsm-t-shirt">BMR Africa Logo 550 GSM T-Shirt</a>.',
    },
    {
      keywords: ['tail logo', 'bmr tail'],
      reply: 'The BMR Tail Logo tee is here: <a href="/products/bmr-tail-logo-550-gsm-t-shirt">BMR Tail Logo 550 GSM T-Shirt</a>.',
    },
    {
      keywords: ['block logo'],
      reply: 'The Block Logo tee is here: <a href="/products/block-logo-600-gsm-t-shirt">Block Logo 600 GSM T-Shirt</a>.',
    },
    {
      keywords: ['yung afrika', 'yung africa'],
      reply: 'Yung Afrika is here: <a href="/products/yung-afrika-550-gsm-t-shirt">Yung Afrika 550 GSM T-Shirt</a>.',
    },
    {
      keywords: ['cart', 'bag', 'basket'],
      reply: 'You can review your cart here: <a href="/cart">Cart</a>. From there, continue to checkout when everything looks right.',
    },
    {
      keywords: ['checkout', 'pay', 'payment', 'card', 'paypal'],
      reply: answers.checkout,
    },
    {
      keywords: ['ship', 'shipping', 'delivery', 'deliver'],
      reply: answers.shipping,
    },
    {
      keywords: ['return', 'refund', 'exchange'],
      reply: answers.returns,
    },
    {
      keywords: ['order', 'tracking', 'track my order', 'where is my order'],
      reply: answers.order,
    },
    {
      keywords: ['contact', 'support', 'human', 'person', 'agent', 'email'],
      reply:
        'For direct support, use the <a href="/pages/contact">Contact page</a> and include your order number if you already purchased.',
    },
    {
      keywords: ['price', 'cost', 'how much'],
      reply:
        'Most active shirt variants are listed at $24.97 USD. Open the product page to confirm the current price before checkout.',
    },
    {
      keywords: ['stock', 'available', 'sold out', 'inventory'],
      reply:
        'Availability is shown on each product page after you choose a color and size. If something is sold out, check <a href="/collections/new-arrivals">new arrivals</a> or another color.',
    },
  ];

  function openAssistant() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');

    window.setTimeout(() => {
      chatInput?.focus();
    }, 60);
  }

  function closeAssistant() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }

  function appendMessage(type, html) {
    const message = document.createElement('div');
    message.className = `bmr-assistant__message bmr-assistant__message--${type}`;
    message.innerHTML = `<p>${html}</p>`;
    messages.append(message);
    messages.scrollTop = messages.scrollHeight;
  }

  function textToHtml(text) {
    return text.replace(/[&<>"']/g, (char) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };

      return entities[char];
    });
  }

  function normalize(text) {
    return text.toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function includesKeyword(query, keyword) {
    const normalizedKeyword = normalize(keyword);

    if (!normalizedKeyword) return false;

    if (normalizedKeyword.includes(' ')) {
      return query.includes(normalizedKeyword);
    }

    return new RegExp(`(^|[^a-z0-9])${escapeRegExp(normalizedKeyword)}([^a-z0-9]|$)`).test(query);
  }

  function getStaticReply(query) {
    const normalizedQuery = normalize(query);

    for (const item of keywordReplies) {
      if (item.keywords.some((keyword) => includesKeyword(normalizedQuery, keyword))) {
        return item.reply;
      }
    }

    return '';
  }

  function getSearchLink(query, label) {
    const safeLabel = label || `Search "${textToHtml(query)}"`;
    return `<a href="${searchUrl}?type=product&q=${encodeURIComponent(query)}">${safeLabel}</a>`;
  }

  async function getProductSuggestions(query) {
    const url = `${predictiveSearchUrl}.json?q=${encodeURIComponent(
      query
    )}&resources[type]=product&resources[limit]=3`;

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });

      if (!response.ok) return [];

      const data = await response.json();
      return data?.resources?.results?.products || [];
    } catch (error) {
      return [];
    }
  }

  function formatProductSuggestions(products, query) {
    if (!products.length) {
      return `I might not have an exact answer for that yet, but I can still help you look around. Try ${getSearchLink(
        query,
        'searching the store'
      )}, or ask about T-shirts, hoodies, sizes, checkout, shipping, or returns.`;
    }

    const links = products
      .map((product) => `<a href="${product.url}">${textToHtml(product.title)}</a>`)
      .join(', ');

    return `I found these matches: ${links}. You can also ${getSearchLink(query, 'view all search results')}.`;
  }

  async function answerFreeText(query) {
    const staticReply = getStaticReply(query);

    if (staticReply) {
      appendMessage('bot', staticReply);
      return;
    }

    appendMessage('bot', 'Let me check the store for that.');

    const products = await getProductSuggestions(query);
    appendMessage('bot', formatProductSuggestions(products, query));
  }

  function answerTopic(topic) {
    const label = topicLabels[topic] || 'Help';
    const answer = answers[topic];

    appendMessage('user', textToHtml(label));

    if (answer) {
      appendMessage('bot', answer);
    }
  }

  toggle?.addEventListener('click', () => {
    if (panel.hidden) {
      openAssistant();

      if (productTitle && !introducedProduct) {
        introducedProduct = true;
        appendMessage(
          'bot',
          `Need help with <strong>${textToHtml(productTitle)}</strong>? I can help with sizes, checkout, colors, and order questions.`
        );
      }
    } else {
      closeAssistant();
    }
  });

  close?.addEventListener('click', closeAssistant);

  assistant.addEventListener('click', (event) => {
    const topicButton = event.target.closest('[data-assistant-topic]');

    if (!topicButton) return;

    answerTopic(topicButton.dataset.assistantTopic);
  });

  chatInput?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    event.preventDefault();

    if (!chatForm) return;

    if (typeof chatForm.requestSubmit === 'function') {
      chatForm.requestSubmit();
      return;
    }

    chatForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  chatForm?.addEventListener('submit', async (event) => {
    event.preventDefault();

    const query = chatInput.value.trim();

    if (!query) {
      appendMessage('bot', 'Ask me about products, sizes, checkout, shipping, returns, or a logo name.');
      chatInput.focus();
      return;
    }

    appendMessage('user', textToHtml(query));
    chatInput.value = '';
    chatInput.disabled = true;

    await answerFreeText(query);

    chatInput.disabled = false;
    chatInput.focus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      closeAssistant();
    }
  });
})();
